<template>
  <section>
    <div id="section-scc-carousel-front-page">
      <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="40000000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
      >
        <div  v-for="(itemSlider, index) in slider" :key="index" >
          <b-carousel-slide
              :img-src="itemSlider.urlImage"
          />

          <div class='scc-carousel-caption d-md-block' :class="slide===itemSlider.order?'active-item':''" v-if="slide==itemSlider.order">
            <div class='container container-content-slider'>
              <h2 class='banner-slider' style='animation-delay:500ms'>{{ itemSlider.bannerSlide }}</h2>
              <div class='container-link-slider' v-if="itemSlider.labelButton !== ''">
                <a
                    :href='itemSlider.linkButton'
                    class='link-slider btn btn-primary animated zoomIn col-6'
                    :class="siteCustomizationData.homePage.sliderCss.showBorderSliderButton ? 'border-on' : 'border-off'"
                    style='animation-delay:500ms'
                >
                  <h3>{{ itemSlider.labelButton }} <font-awesome-icon :icon="[ 'fas', 'chevron-right' ]" aria-hidden='true' v-if="itemSlider.showArrow === '1'"/></h3>
                </a>
              </div>
            </div>
          </div>
        </div>
      </b-carousel>
    </div>
    <div id="bottom-block" class="row">
      <div class="col-12 col-lg-6 bottom-col bottom-col-left">
        <h2
            v-if ="siteCustomizationData.homePage.textBlocks.leftTextBlockHeader !== ''"
        >
          {{ siteCustomizationData.homePage.textBlocks.leftTextBlockHeader }}
        </h2>
        <div class="bottom-block-text">
          <div
              class="par-text-bottom-left"
              v-if="siteCustomizationData.homePage.textBlocks.leftTextBlockBody !== ''"
              style="white-space: pre-line;"
          >
            {{ siteCustomizationData.homePage.textBlocks.leftTextBlockBody }}
            <a
                class="par-text-bottom-left"
                v-if="siteCustomizationData.homePage.textBlocks.leftTextBlockLink !== ''"
                :href="siteCustomizationData.homePage.textBlocks.leftTextBlockLinkAddress"
            >
             {{ siteCustomizationData.homePage.textBlocks.leftTextBlockLink }}
            </a>
          </div>
        </div>
        <a
            v-if="siteCustomizationData.homePage.textBlocks.leftTextBlockButton !==''"
            :href="siteCustomizationData.homePage.textBlocks.leftTextBlockButtonLink"
            style="text-decoration: none;"
        >
          <span class="button-section btn">
              {{ siteCustomizationData.homePage.textBlocks.leftTextBlockButton }}
          </span>
        </a>
      </div>
      <div class="col-12 col-lg-6 bottom-col bottom-col-left">
        <h2
            v-if ="siteCustomizationData.homePage.textBlocks.rightTextBlockHeader !== ''"
        >
          {{ siteCustomizationData.homePage.textBlocks.rightTextBlockHeader }}
        </h2>
        <div class="bottom-block-text">
          <div
              class="par-text-bottom-left"
              v-if="siteCustomizationData.homePage.textBlocks.rightTextBlockBody !== ''"
              style="white-space: pre-line;"
          >
            {{siteCustomizationData.homePage.textBlocks.rightTextBlockBody}}
            <a
                class="par-text-bottom-left"
                v-if="siteCustomizationData.homePage.textBlocks.rightTextBlockLink !== ''"
                :href="siteCustomizationData.homePage.textBlocks.rightTextBlockLinkAddress"
            >
              {{siteCustomizationData.homePage.textBlocks.rightTextBlockLink}}
            </a>
          </div>
        </div>
        <a
            v-if="siteCustomizationData.homePage.textBlocks.rightTextBlockButton !==''"
            :href="siteCustomizationData.homePage.textBlocks.rightTextBlockButtonLink"
            style="text-decoration: none;"
        >
          <span class="button-section btn">
              {{ siteCustomizationData.homePage.textBlocks.rightTextBlockButton }}
          </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "home",
  data(){
    return {
      slide: 0,
      sliding: null,
      slider: [],
      activitySlide: 0,
    }
  },
  computed : {
    ...mapState({
      siteCustomizationData: state => state.settingsAndCustomize.siteCustomizationData
    })
  },
  async created() {
    this.slider = await this.$store.dispatch('pages/SET_homeSlider')
    this.customStyle();
  },
  methods: {
    customStyle() {
      document.getElementById('section-scc-carousel-front-page').style.setProperty("--SliderBannerColor", this.siteCustomizationData.homePage.sliderCss.colorBanner );
      document.getElementById('section-scc-carousel-front-page').style.setProperty("--HoverTextButtonColorSlider", this.siteCustomizationData.homePage.sliderCss.colorTextButtonHover );
      if (this.siteCustomizationData.homePage.sliderCss.colorButtonHover !== ''){
        document.getElementById('section-scc-carousel-front-page').style.setProperty("--HoverButtonColorSlider", this.siteCustomizationData.homePage.sliderCss.colorButtonHover);
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSlideStart(slide) {
      this.sliding = true
    },
    // eslint-disable-next-line no-unused-vars
    onSlideEnd(slide) {
      this.sliding = false
    },
  }
}
</script>
<style>
  body .carousel-control-prev, body .carousel-control-next {
    z-index: 11;
    display: none;
  }
  .carousel-item{
    width: 100%;
    height: 430px;
  }
  .carousel-item img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 500px) {
    .carousel-item{
      height: 300px;
    }
  }
  @media (max-width: 380px) {
    .carousel-item{
      height: 200px;
    }
  }
</style>
<style scoped>
  #section-scc-carousel-front-page{
    --SliderBannerColor: #fff;
    --HoverTextButtonColorSlider: #000;
    --HoverButtonColorSlider: #ffffff00;
  }
  .container-content-slider{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-left: 70px;
  }
  .scc-carousel-caption{
    position: absolute;
    display: none;
    width: 100%;
    height: 100%;
  }
  .active-item{
    display: flex!important;
    z-index: 10;
  }
  #section-scc-carousel-front-page h2{
    color: var(--SliderBannerColor);
  }
  #section-scc-carousel-front-page h3{
    margin: 0;
  }
  .link-slider {
    display: inline-table;
    width: auto;
    height: 40px;
    max-width: 300px;
    border-radius: 0;
    background-color: transparent;
    border-color: var(--SliderBannerColor);
    color: var(--SliderBannerColor);
  }
  .link-slider:hover, .link-slider:active, .link-slider:hover {
    color: var(--HoverTextButtonColorSlider);
    background-color: var(--HoverButtonColorSlider);
    border-color: var(--HoverButtonColorSlider);
  }
  #bottom-block{
    width: 50%;
    margin-right: auto;
    margin-left: auto;
  }
  .bottom-col{
    display: flex;
    flex-direction: column;
  }
  .bottom-col-left{
    padding: 20px 70px 20px 20px;
    align-items: start;
    text-align: start;
  }
  .bottom-col-right{
    padding: 20px 20px 20px 7px;
    align-items: start;
  }
  .bottom-col h2{
    color: var(--ButtonColor);
  }
  .bottom-block-text{
    height: 100%;
  }
  .button-section{
    margin-top: 30px;
    background-color: var(--ButtonColor);
    color: var(--ButtonTextHover);
  }
  .button-section:hover{
    background-color: transparent;
    color: var(--BasicFontColor);
  }
  .border-on{
    border: 1px solid;
  }
  .border-off{
    border: 0;
  }
  a .button-section{
    min-width: 120px;
    display: flex;
    justify-content: center;
  }
  @media (max-width: 1200px) {
    #bottom-block{
      width: 80%;
    }
  }
  @media (max-width: 992px) {
    #bottom-block{
      width: 50%;
    }
    .bottom-col-right{
      padding: 20px 70px 20px 20px;
    }
  }
  @media (max-width: 800px) {
    #bottom-block{
      width: 100%;
    }
  }
</style>
